export const encodingClothsImages: string[] =
  ['./assets/images/clothColors/cap-green.png',
    './assets/images/clothColors/jacket-red.png',
    './assets/images/clothColors/pants-blue.png',
    './assets/images/clothColors/cap-yellow.png',
    './assets/images/clothColors/jacket-green.png'];
